class PasswordModal extends DetailsModal{constructor(){super(),this.querySelector('input[aria-invalid="true"]')&&this.open({target:this.querySelector("details")})}}customElements.define("password-modal",PasswordModal);
//# sourceMappingURL=/s/files/1/0687/2193/4620/t/24/assets/password-modal.js.map?v=1705977526
